window.addEventListener('DOMContentLoaded', () => {
	let imagesModal = document.querySelectorAll('.image-with-text__modal');
	
	imagesModal.forEach((image) => {
		image.addEventListener('click', () => {
			openModal(image)
		})
	})
})

function openModal(img) {
  let modal = document.querySelector("#myModal");

  let modalImg = modal.querySelector("#img01");
  
  modalImg.src = img.src;
  modal.style.cssText = 'display:flex !important';

  let span = modal.querySelector(".close");

  span.onclick = function() {
    closeModal(modal, modalImg);
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      closeModal(modal, modalImg);
    }
  }
}

function closeModal(modal, modalImg) {
  modal.style.display = "none";
	modalImg.src = '';
}
